export default {"src":"/_next/static/media/certik.2bb51929.svg","height":287,"width":1204,"blurWidth":0,"blurHeight":0};